// extracted by mini-css-extract-plugin
export default {"logs":"ProductLogs_logs__5Qvd8"};